var _getRand = (min, max) => {
    return (Math.floor(Math.random() * (max + 1 - min) + min))
}
/// Поле, хранит текст для капчи
var imageText = ''

/// Метод принимает айдишку (предположительно div), в который будет выброшена капча
export function init(divCaptcha) {
    let divTxt = `
<label for="lblCaptcha">Пройдите проверку на человека</label>
<form id="mailFormCanvas">
	<div class="form-group">
		<canvas id="canvasCaptcha" style="border: 1px solid black; " width="200" height="100"></canvas>
		<div class="input-group" style="width:200px; height:27px; margin-top:2px">
			<input id="tbCaptcha" type="captcha" class="form-control input-sm" style="border-color: red;" name="captcha"/>
			<div class="input-group-append">
				<button id="btnRefreshCaptcha" type="button" style="margin-left: 2px" class="btn-sm btn-primary">
					<span class="glyphicon glyphicon-refresh"/>
				</button>
			</div>
		</div>
	</div>
</form>
`
    $(`#${divCaptcha}`).append(divTxt)
    $('#btnRefreshCaptcha').on('click', () => {
        imageText = getRandomImageText()
        setCanvasWithCaptcha(imageText)
        checkTextInCaptcha()
    })
    $('#tbCaptcha').on('input propertychange paste', checkTextInCaptcha)
    imageText = getRandomImageText()
    setCanvasWithCaptcha(imageText)
}
/// Метод для поверки совпадения текста с содержимым капчи
export var checkTextInCaptcha = () => {
    let tbCaptcha = $('#tbCaptcha')
    let isValid = tbCaptcha.val() == imageText
    tbCaptcha.css({
        'border-color': isValid
            ? '#ccc'
            : 'red'
    })
    return isValid
}

/// Метод, рисует текст в канве (прокатит для любой канвы с названием canvasCaptcha)
export var setCanvasWithCaptcha = (randText) => {
    let canva = document.getElementById("canvasCaptcha")
    let ctx = canva.getContext("2d"); // Создаю канву
    ctx.clearRect(0, 0, canva.width, canva.height) // Чищу канвас (в случае, если кто то вызвал этот метод с уже заполненной канвой)
    ctx.beginPath();
    ctx.fillStyle = "#FFFFFF"
    ctx.stroke()
    for (let i = 0; i < _getRand(3, 5); i++) {
        ctx.strokeStyle = `#${_getRand(0, 9)}F${_getRand(0, 9)}F${_getRand(0, 9)}F`;
        ctx.moveTo(_getRand(0, 200), _getRand(0, 100))
        ctx.lineTo(_getRand(0, 200), _getRand(0, 100))
        ctx.stroke()
    }
    for (let i = 0; i < randText.length; i++) {
        ctx.font = `${_getRand(18, 32)}px Arial`

        ctx.fillStyle = `#${_getRand(0, 9)}F${_getRand(0, 9)}F${_getRand(0, 9)}F`;
        ctx.textAlign = 'center'
        ctx.fillText(randText[i], canva.clientWidth * 0.2 + (15 * i), canva.clientHeight / 2 + _getRand(-8, 8))
    }
}

/// Метод, создаёт случайное содержимое капчи
export var getRandomImageText = () => {
    let randText = ''
    for (let i = 0; i < _getRand(12, 5); i++)
        randText += String.fromCharCode(_getRand(0, 1) == 1
            ? (_getRand(0, 1) == 1
                ? "A"
                : "a").charCodeAt(0) + _getRand(0, 26)
            : "0".charCodeAt(0) + _getRand(0, 9)) // Рандомлю буквы или цифры
    return randText
}